module.exports = __webpack_public_path__ + "img/truck-billing.b45d9834.svg";